import { Component, Input } from '@angular/core';
import { CaptureQueueResult } from '../../../core/models/capture-lists/capture-queue-result.model';
import { CaptureStatus } from '../../../core/enums/capture-status.enum';
import { ClaimSourceOptions } from '../../../core/options/claim-source.opts';
import { NgClass, CurrencyPipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { UserPresenceComponent } from '../../../shared/components/user-presence/user-presence.component';
import { ExpirationDateComponent } from '../../../shared/components/expiration-date/expiration-date.component';
import { PatientNameComponent } from '../../../shared/components/patient-name/patient-name.component';
import { CandidatePatientNameComponent } from '../../../captures/components/candidate-patient-name/candidate-patient-name.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { CandidateDrugComponent } from '../../../captures/components/candidate-drug/candidate-drug.component';
import { CaptureStatusPipe } from 'app/shared/pipes/capture-status.pipe';
import { CaptureStatusReasonPipe } from '../../../shared/pipes/capture-status-reason.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-capture-queue-results',
    templateUrl: './capture-queue-results.component.html',
    styleUrls: ['./capture-queue-results.component.scss'],
    imports: [RouterLink,
              UserPresenceComponent,
              NgClass,
              ExpirationDateComponent,
              PatientNameComponent,
              CandidatePatientNameComponent,
              PrescriberNameComponent,
              CandidateDrugComponent,
              CurrencyPipe,
              DatePipe,
              CaptureStatusPipe,
              CaptureStatusReasonPipe,
              BlankValueDashPipe]
})
export class CaptureQueueResultsComponent {
  captureStatus = CaptureStatus;
  claimSourceDisplay = {};

  @Input() captureQueueResults: CaptureQueueResult[] = [];
  @Input() displayPatient = true;
  @Input() displayClient = true;
  @Input() displayProvider = true;
  @Input() openInNewTab = false;
  @Input() internalConsultantView = false;

  constructor() {
    ClaimSourceOptions.forEach(opt => {
      this.claimSourceDisplay[opt.value] = opt.display;
    });
  }
}
